/** The card's width, matching InfoCard's. */
export const POPOVER_INFO_CARD_WIDTH = 500;

/** The body scrolls past this height, matching InfoCard's. */
export const POPOVER_INFO_CARD_BODY_MAX_HEIGHT = 630;
